module.exports = __webpack_public_path__ + "static/media/18.89001b3b.jpg";